<template>
  <div class="contents bg-bk">
    <div class="kv">
      <img src="/img/logo/white_je.png" class="logo" alt="JAPAN EDITION">
      <div class="layer"></div>
      <img src="/img/concept/S__42090809.jpg" class="image" alt="JAPAN EDITION">
    </div>
    <div class="concept container" id="bg-inversion">
      <h2>CONCEPT</h2>
      <div>
        <p>古くから受け継がれてきた技と美意識を、いまの時代の感性で再構築する。<br>
          日本の職人の手仕事、伝統素材、そしてその背景に流れる精神を、<br>
          現代のデザインとして世界へ発信するコンセプトショップ。<br>
          ここには、過去と未来、伝統と革新が共鳴する“今の日本”があります。<br>
          ものづくりに込められた物語を、世界へ丁寧に紡ぎ届けます.</p>
        <p>Reconstructing time-honored craftsmanship and aesthetics through the lens of modern sensibility.<br>
          A concept shop that showcases the delicate handiwork of Japanese artisans, traditional materials,<br>
          and the spirit that flows through them — reimagined as contemporary design for the world.<br>
          <br>Here, the past and the future, tradition and innovation resonate together to express “Japan of today.”<br>
          We share the stories behind each creation with care, connecting them to the world.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Concept',
  // Your script code here
};
</script>

<style scoped lang="scss">
.kv {
  position: relative;
  img {
    display: block;
    width: 100vw;
  }
  .layer {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .logo {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
    max-width: 100%;
    height: auto;
    width: 50vw;
    max-width: 300px;
  }
  .image {
    margin: 0 auto;
  }
}

.concept {
  text-align: center;
  padding-bottom: 3em;
  h2 {
    font-size: 1.5em;
    font-weight: normal;
    margin: 4em 0;
  }
  p {
    font-size: .9em;
    line-height: 2;
    &:not(:first-child) {
      margin-top: 2em;
    }
  }
}
</style>
